var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    {
      staticClass: "feedback-summary row",
      attrs: {
        "aria-label": "Question Summary",
        id: "feedback",
        tabindex: "-1"
      }
    },
    [
      _vm.isGraded && !_vm.hasUnsaved
        ? [
            _c("div", { attrs: { "aria-live": "polite" } }, [
              _c("div", { staticClass: "summary col-md-6" }, [
                ["S", "N"].indexOf(_vm.activeQuestion.QUESTION_TYPE) > -1
                  ? _c(
                      "div",
                      _vm._l(_vm.studentAnswer, function(ans) {
                        return _c("p", { key: ans.TEST_QUESTION_ANSWER_TEXT }, [
                          _vm._v(
                            "\n\t\t\t\t\t\t" +
                              _vm._s(
                                _vm.$t(
                                  "MAIN_CONTENT.QuestionSummary.yourAnswer"
                                )
                              ) +
                              " "
                          ),
                          _c("b", [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t" +
                                _vm._s(ans.TEST_QUESTION_ANSWER_TEXT) +
                                "\n\t\t\t\t\t\t"
                            )
                          ]),
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("MAIN_CONTENT.QuestionSummary.is")
                              ) +
                              " \n\t\t\t\t\t\t"
                          ),
                          _vm.isCorrect(ans)
                            ? _c("span", [
                                _c(
                                  "b",
                                  { staticClass: "color-correct-lighten" },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t" +
                                        _vm._s(
                                          _vm.$t(
                                            "MAIN_CONTENT.QuestionSummary.correct"
                                          )
                                        ) +
                                        "\n\t\t\t\t\t\t\t"
                                    )
                                  ]
                                )
                              ])
                            : ans.POINTS_EARNED > 0
                            ? _c("span", [
                                _c(
                                  "b",
                                  { staticClass: "color-correct-lighten" },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t" +
                                        _vm._s(
                                          _vm.$t(
                                            "MAIN_CONTENT.QuestionSummary.partiallyCorrect"
                                          )
                                        ) +
                                        "\n\t\t\t\t\t\t\t"
                                    )
                                  ]
                                )
                              ])
                            : _c("span", [
                                _c(
                                  "b",
                                  { staticClass: "color-incorrect-lighten" },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t" +
                                        _vm._s(
                                          _vm.$t(
                                            "MAIN_CONTENT.QuestionSummary.incorrect"
                                          )
                                        ) +
                                        "\n\t\t\t\t\t\t\t"
                                    )
                                  ]
                                )
                              ])
                        ])
                      }),
                      0
                    )
                  : ["C", "T"].indexOf(_vm.activeQuestion.QUESTION_TYPE) > -1
                  ? _c(
                      "div",
                      _vm._l(_vm.studentAnswer, function(ans) {
                        return _c("p", { key: ans.ANSWER_RID }, [
                          _vm._v(
                            "\n\t\t\t\t\t\t" +
                              _vm._s(
                                _vm.$t(
                                  "MAIN_CONTENT.QuestionSummary.yourAnswer"
                                )
                              ) +
                              " "
                          ),
                          _c("b", [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t" +
                                _vm._s(
                                  _vm.getAnswerChoiceNumber(ans.ANSWER_RID)
                                ) +
                                "\n\t\t\t\t\t\t\t"
                            )
                          ]),
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("MAIN_CONTENT.QuestionSummary.is")
                              ) +
                              "\n\t\t\t\t\t\t"
                          ),
                          ans.POINTS_EARNED > 0
                            ? _c("span", [
                                _c(
                                  "b",
                                  { staticClass: "color-correct-lighten" },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t" +
                                        _vm._s(
                                          _vm.$t(
                                            "MAIN_CONTENT.QuestionSummary.correct"
                                          )
                                        ) +
                                        "\n\t\t\t\t\t\t\t"
                                    )
                                  ]
                                )
                              ])
                            : _c("span", [
                                _c(
                                  "b",
                                  { staticClass: "color-incorrect-lighten" },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t" +
                                        _vm._s(
                                          _vm.$t(
                                            "MAIN_CONTENT.QuestionSummary.incorrect"
                                          )
                                        ) +
                                        "\n\t\t\t\t\t\t\t"
                                    )
                                  ]
                                )
                              ])
                        ])
                      }),
                      0
                    )
                  : ["M"].indexOf(_vm.activeQuestion.QUESTION_TYPE) > -1
                  ? _c(
                      "div",
                      _vm._l(_vm.studentAnswer, function(subQ) {
                        return _c("p", { key: subQ.TEST_QUESTION_RID }, [
                          _vm._v(
                            "\n\t\t\t\t\t\t" +
                              _vm._s(
                                _vm.$t(
                                  "MAIN_CONTENT.QuestionSummary.yourAnswer"
                                )
                              ) +
                              " \n\t\t\t\t\t\t"
                          ),
                          _c("b", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.getMatchText(subQ.ANSWER_RID)
                              )
                            }
                          }),
                          _vm._v(
                            " \n\t\t\t\t\t\t" +
                              _vm._s(
                                _vm.$t("MAIN_CONTENT.QuestionSummary.is")
                              ) +
                              "\n\t\t\t\t\t\t"
                          ),
                          subQ.ANSWER_CORRECT_FLG
                            ? _c("span", [
                                _c(
                                  "b",
                                  { staticClass: "color-correct-lighten" },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t" +
                                        _vm._s(
                                          _vm.$t(
                                            "MAIN_CONTENT.QuestionSummary.correct"
                                          )
                                        ) +
                                        "\n\t\t\t\t\t\t\t"
                                    )
                                  ]
                                )
                              ])
                            : subQ.POINTS_EARNED > 0
                            ? _c("span", [
                                _c(
                                  "b",
                                  { staticClass: "color-correct-lighten" },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t" +
                                        _vm._s(
                                          _vm.$t(
                                            "MAIN_CONTENT.QuestionSummary.partiallyCorrect"
                                          )
                                        ) +
                                        "\n\t\t\t\t\t\t\t"
                                    )
                                  ]
                                )
                              ])
                            : _c("span", [
                                _c(
                                  "b",
                                  { staticClass: "color-incorrect-lighten" },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t" +
                                        _vm._s(
                                          _vm.$t(
                                            "MAIN_CONTENT.QuestionSummary.incorrect"
                                          )
                                        ) +
                                        "\n\t\t\t\t\t\t\t"
                                    )
                                  ]
                                )
                              ])
                        ])
                      }),
                      0
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("div", [
                  _c("span", { staticClass: "pill pill-dark" }, [
                    _c("strong", [_vm._v(_vm._s(_vm.pointsEarned))]),
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$t("MAIN_CONTENT.QuestionSummary.ptsEarned")
                        ) +
                        "\n\t\t\t\t\t"
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _vm.isGraded && !_vm.hasUnsaved
                ? _c("div", { staticClass: "feedback col-md-6" }, [
                    _vm.hasFeedback
                      ? _c(
                          "div",
                          { staticClass: "speech-bubble" },
                          [
                            _c("div", { staticClass: "arrow bottom" }),
                            _vm._v(" "),
                            _vm._l(_vm.studentAnswer, function(ans, index) {
                              return _c("div", { key: index }, [
                                !!ans.ANSWER_SPECIFIC_FEEDBACK &&
                                ans.ANSWER_SPECIFIC_FEEDBACK.length > 0 &&
                                (index === 0 ||
                                  _vm.studentAnswer[index - 1]
                                    .ANSWER_SPECIFIC_FEEDBACK !==
                                    ans.ANSWER_SPECIFIC_FEEDBACK)
                                  ? _c("p", {
                                      domProps: {
                                        innerHTML: _vm._s(
                                          ans.ANSWER_SPECIFIC_FEEDBACK
                                        )
                                      }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                index === _vm.studentAnswer.length - 1 &&
                                !!ans.GENERAL_QUESTION_FEEDBACK &&
                                ans.GENERAL_QUESTION_FEEDBACK.length > 0
                                  ? _c("p", {
                                      domProps: {
                                        innerHTML: _vm._s(
                                          ans.GENERAL_QUESTION_FEEDBACK
                                        )
                                      }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                index === _vm.studentAnswer.length - 1 &&
                                !!ans.QUESTION_GRADED_COMMENTS &&
                                ans.QUESTION_GRADED_COMMENTS.length > 0
                                  ? _c("p", {
                                      domProps: {
                                        innerHTML: _vm._s(
                                          ans.QUESTION_GRADED_COMMENTS
                                        )
                                      }
                                    })
                                  : _vm._e()
                              ])
                            })
                          ],
                          2
                        )
                      : _vm._e()
                  ])
                : _vm._e()
            ])
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }